import * as React from 'react';

import { Button } from 'components/bootstrap';
import { SelectedRowsProvider, useSelectedRows } from 'common/contexts';
import { Modal, Row } from 'common/components';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

import EventProcedureStepLibraryList from './List';

type Props = {
  selectedSteps: Array<EventProcedureStepAPIType>;
  onClose: () => void;
  onAdd: (steps: Array<EventProcedureStepAPIType>) => void;
};

const Buttons = ({ onClose, onAdd }: Omit<Props, 'selectedSteps'>) => {
  const selectedRows = useSelectedRows();
  const selectedSteps = React.useMemo(
    () =>
      selectedRows.map((step: EventProcedureStepAPIType & { type: string }) => {
        // eslint-disable-next-line no-param-reassign
        delete step.type;

        return step;
      }),
    [selectedRows],
  );

  return (
    <Row $justify="flex-end" $align="center">
      <Button onClick={onClose}>Cancel</Button>
      <Button bsStyle="primary" disabled={selectedRows.length < 1} onClick={() => onAdd(selectedSteps)}>
        Add Steps
      </Button>
    </Row>
  );
};

function EventProcedureStepLibraryForm({ selectedSteps, onClose, onAdd }: Props) {
  return (
    <SelectedRowsProvider>
      <Modal
        show
        onClose={onClose}
        maxWidth="800px"
        title="Add Step from Library"
        buttons={<Buttons onClose={onClose} onAdd={onAdd} />}>
        <EventProcedureStepLibraryList selectedSteps={selectedSteps} />
      </Modal>
    </SelectedRowsProvider>
  );
}

export default EventProcedureStepLibraryForm;
